import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getProjects, getProjectForms } from '../../services/projectService';
import { getFormWidgets } from '../../services/formService';
import { WidgetTypes } from '../../constants/QuestionTypes';
import _ from 'lodash';
import { stripTags } from '../common/commonFuncs';
import CustomLoader from '../common/Loader';
import * as Icon from 'react-feather';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import { logActivity } from '../../services/utilService';
import MUIDataTable from 'mui-datatables';
import ReportSettings from './ReportSettings';

class AddReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            loading: true,
            projects: [],
            projectSelected: {},
            projectForms: [],
            formSelected: {},
            formsWidgetsList: [],
            reportList: [],
            selectedFormWidgetsList: [],
        };
    }

    componentDidMount() {
        this.loadProjects().
            then(
                () => {
                    this.setState({ loading: false });
                });
    }

    loadProjects = async () => {
        const { data: projects } = await getProjects();
        this.setState({ projects });
        console.log('Add New p', projects)
    };

    render() {
        const { preloadData, projects } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <div className='card card-header-actions'>
                            <div className='card-body'>
                                <div className='align-items-center justify-content-between'>
                                    <h4 className='ml-2'>{(preloadData ? 'Edit' : 'Add New') + ' Report'}</h4>
                                    <div class='row ml-2 mt-4'>
                                        <span className='col col-md-1'>Report Name</span>
                                        <input type='search' id='' name='' className='col col-md-3 form-inline form-control' />
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-1 align-top'>Report Description</span>
                                        <textarea className='col col-md-3 form-inline form-control' id='' name='' rows={2} />
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-1'>Select a Project</span>
                                        <select className='btn btn-lg dropdown-toggle border col col-md-3'>
                                            {
                                                projects.map((p) => {
                                                    return (<option>{p.Project_Name}</option>);
                                                })
                                            }
                                        </select>
                                    </div><br /><br />
                                    <div class='row ml-2'>
                                        <button className='btn btn-primary ml-2'>{preloadData ? 'Edit' : 'Add'}</button>
                                        <button className='btn btn-success ml-2'>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Add Report: ', e);
            return (loading);
        }
    }
}

export default withRouter(AddReport);